import { levelFor } from "@/lib/gamification";

export function PointsBadge({
  points,
  onClick,
}: {
  points: number;
  onClick: () => void;
}) {
  const { current, next, progress } = levelFor(points);
  return (
    <button
      onClick={onClick}
      aria-label={`Nivel ${current.label}, ${points} puntos`}
      title={`${current.label} · ${points} pts${next ? ` · ${next.min - points} para ${next.label}` : ""}`}
      className="flex items-center gap-1.5 rounded-lg glass px-2 py-1.5 text-[11px] font-bold transition hover:bg-accent"
    >
      <span aria-hidden className="text-sm leading-none">{current.emoji}</span>
      <div className="hidden sm:flex flex-col items-start leading-tight">
        <span className="text-[9px] tracking-widest text-muted-foreground">{current.label.toUpperCase()}</span>
        <span className="tabular-nums">{points} pts</span>
      </div>
      <span className="sm:hidden tabular-nums">{points}</span>
      <div className="hidden md:block h-1 w-12 overflow-hidden rounded-full bg-secondary">
        <div
          className="h-full bg-gradient-to-r from-[oklch(0.58_0.24_27)] to-[oklch(0.82_0.24_145)]"
          style={{ width: `${progress}%` }}
        />
      </div>
    </button>
  );
}